export default function initGalleryDownload() {
  const triggers = document.querySelectorAll('[data-gallery-download]');
  const modal = document.querySelector('[data-download-modal]');

  if (!triggers.length || !modal) return;

  const confirmLink = modal.querySelector('[data-download-confirm]');
  const cancelButton = modal.querySelector('[data-download-cancel]');

  if (!confirmLink || !cancelButton) return;

  let lastFocusedElement = null;

  function getFocusableElements() {
    return modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function openModal(downloadUrl) {
    lastFocusedElement = document.activeElement;

    confirmLink.href = downloadUrl;

    modal.hidden = false;
    document.body.classList.add('is-download-modal-open');

    // Enfocamos Cancelar primero para evitar descarga accidental con Enter.
    cancelButton.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('is-download-modal-open');

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal(trigger.href);
    });
  });

  cancelButton.addEventListener('click', closeModal);

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(getFocusableElements());

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}